import { assign, map, get } from 'lodash'
import LOGIN_TO_PATIENT from '@/plugins/http/patient.js'

const resultScrollTo = require('vue-scrollto')

/** tratando se for develop */
const getHost = () => {
  if (get(process.env, 'NODE_ENV') === 'development') {
    return window.location.host.replace(':8080', '')
  } else {
    return window.location.host
  }
}
const splitPrice = (item) => {
  if (!item.price) {
    return [null, null]
  }
  return item.price.toString().split('.')
}
const splitConv = (item) => {
  if (!item.covenant) {
    return [null, null]
  }
  return item.covenant.toString().split(',')
}

const parsedSchedule = (item) => {
  const schedules = assign({}, item)
  const price = splitPrice(schedules)
  const conv = splitConv(schedules)
  const convTotal = conv.length

  schedules._parsed = {
    'conve_total': convTotal,
    'price_real': price[0],
    'price_cents': price[1],
    'covenant_1': conv[0],
    'covenant_2': conv[1],
    'covenant_3': conv[2],
    'covenant_4': conv[3],
    'covenant_5': conv[4],
    'covenant_6': conv[6]
  }

  return schedules
}

export default {
  checkDomainOperator () {
    const host = {
      domain: getHost()
    }
    this.$http.post('v1/scheduling/see/operator/domain', host)
      .then(({data}) => {
        /** Removendo valores anteriores */
        const operatorCovenantSession = localStorage.getItem('operador-covenant')
        if (operatorCovenantSession !== null) {
          localStorage.removeItem('operador-covenant')
        }

        /** setando dominio da operadora */
        localStorage.setItem('operador-domain', getHost())

        /** se tem resultado  */
        if (data.length > 0) {
          localStorage.setItem('operador-covenant', data[0].name)
        }
      })
      .catch((error) => {
        this.loading = false
        this.afterFailure(error)
      })
  },
  toApresentation () {
    resultScrollTo.scrollTo('#intro')
  },
  // aparecendo o preço para o paciente
  setHide: function (item) {
    if (item.hide !== true) {
      this.$set(item, 'hide', true)
    }
  },
  doLoad () {
    this.$http.get('/v1/search/loading/location')
      .then(({data}) => {
        this.ipstack = 'Curitiba'
        this.search.cityName = 'Curitiba'
      })
  },
  onSelectedSpeciality (speciality) {
    if (speciality !== null) {
      this.search.speciality = speciality.id
      this.search.specialityName = speciality.name
    }
  },
  onSelectedCity (cities) {
    if (cities !== null) {
      this.search.cityName = cities.city
      this.search.city = cities.id
    }
  },
  doSearch () {
    const search = {
      includes: this.includes,
      // ...this.defaultSearch,
      ...this.search,
      operator: getHost(),
      pagination: false
    }
    this.loading = true
    this.isBlock = true
    this.notShow = true
    // total e agenda
    this.$http.get('v1/scheduling/see/total')
      .then((data) => {
        this.totalAgendas = data
        this.showLabelSearch = true
      })
      .catch((error) => {
        this.afterFailure(error)
      })
    this.$resource.get('', this.prepareSearch(search))
      .then(({data, meta}) => {
        this.operatorCovenant = localStorage.getItem('operador-covenant')
        resultScrollTo.scrollTo('#results')
        this.schedules = map(data, parsedSchedule)
        this.scheduleTotal = meta.pagination.total
        this.showLabelSearch = true
        this.schedule.total = this.pagination.total
        this.pagination = meta.pagination
        this.loading = false
      })
      .catch((error) => {
        this.loading = false
        this.afterFailure(error)
      })
  },
  moreCovenant (value) {
    const result = (value - 5)
    if (result <= 0) {
      return false
    }
    return true
  },
  showMoreResults () {
    window.location.href = LOGIN_TO_PATIENT
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/gadget/resources/methods.js